export default __webpack_public_path__ + "static/media/blue-avatar.e72bb894.png";